import { render } from "./quoteDetail.vue?vue&type=template&id=6b0897d6"
import script from "./quoteDetail.vue?vue&type=script&lang=js"
export * from "./quoteDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__